<script lang="ts" setup>
import MainLayout from "../../../../packages/view/src/components/MainLayout.vue";
import Root from "../../../../packages/view/src/components/Root.vue";
import AppVersion from "../../view/components/AppVersion.vue";
</script>

<template>
  <Root>
    <MainLayout>
      <slot />
    </MainLayout>

    <AppVersion></AppVersion>
  </Root>
</template>
